var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSvgLikeIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 20,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#C2C2C2",
  fillRule: "evenodd",
  d: "M10.197 1.746c.144-.27.463-.445.816-.445 1.973 0 3.572 1.343 3.572 3v2.25h4.46c.783-.006 1.53.276 2.045.773.516.498.745 1.162.627 1.814l-1.232 6.75c-.2 1.108-1.34 1.923-2.673 1.913H7.442c-.493 0-.893-.336-.893-.75V8.8a.65.65 0 0 1 .077-.305zm1.359 1.125L8.335 8.96v7.34h9.492c.445.005.826-.267.893-.637l1.232-6.75a.67.67 0 0 0-.21-.604.98.98 0 0 0-.683-.258h-5.367c-.493 0-.893-.336-.893-.75v-3c0-.67-.522-1.237-1.243-1.43",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#C2C2C2",
  fillRule: "evenodd",
  d: "M5.064 7.967h2.377c.493 0 .893.336.893.75v8.333c0 .414-.4.75-.893.75H5.064c-1.495.019-2.771-.904-2.972-2.15a1 1 0 0 1-.008-.1V10.3q0-.05.008-.1c.193-1.196 1.42-2.252 2.972-2.233m-1.194 2.39v5.136c.1.471.596.816 1.171.807h1.507V9.467H5.041c-.52-.008-1.062.369-1.171.89",
  clipRule: "evenodd"
})));
export default SvgSvgLikeIcon;